import * as React from 'react';
import { CssBaseline, Theme, createStyles, withStyles, WithStyles } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router';
import WelcomeHeader from '../Header/WelcomeHeader';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(),
        marginLeft: theme.spacing(),
        marginRight: theme.spacing()
    },
    card: {
        maxWidth: 345,
    },
    media: {
        objectFit: 'cover',
        backgroundColor: '#26f2bf'
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        padding: 0,
        height: '100vh',
        overflow: 'auto',
    },
    iframeContent: {
        width: '100%',
        height: '100vh'
    }
})

class Welcome extends React.Component<WithStyles<typeof styles> & RouteComponentProps> {
    private iframeRef: HTMLIFrameElement | null;


    private onIFrameLoaded() {
        this.iframeRef!.contentWindow!.postMessage('hideHeader', '*')
    }

    componentDidMount() {
    }

    public render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <CssBaseline />
                <WelcomeHeader />
                <div className={classes.content}>
                    <div className={classes.appBarSpacer}>
                        <iframe id='kleerdata_iframe' src={location.protocol + '//kleerdata.com'}
                            className={classes.iframeContent} onLoad={this.onIFrameLoaded.bind(this)} ref={(ref) => this.iframeRef = ref} />
                    </div>
                </div>
            </React.Fragment >
        )
    }
}
export default withStyles(styles)(withRouter(Welcome))


// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.tsx